import type { SupportedLocale } from "staticConfiguration";
import { createContext } from "react";

export const LocaleContext = createContext<SupportedLocale>("en");
LocaleContext.displayName = "LocaleContext";
